import styled from 'astroturf/react';

import ButtonA from 'src/components/Button';
import CheckboxA from 'src/components/Checkbox/Checkbox';

const BottomInfoWrapper = styled('div')`
  display: flex;
`;

const BottomWrapper = styled('div')`
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  width: calc(100% + 40px);
  margin-left: -20px;
  background: var(--ph-gray-50);
  color: var(--ph-gray-700);
  margin-bottom: -20px;
  padding: 30px 40px 30px 45px;
  border-bottom-left-radius: var(--ph-border-radius-sm);
  border-bottom-right-radius: var(--ph-border-radius-sm);
`;

const Button = styled(ButtonA)`
  font-size: var(--ph-text-sm);
  padding-left: 12px;
  padding-right: 12px;
  height: 32px;
  width: 105px;
  user-select: none;
`;

const ButtonsWrapper = styled('div')`
  display: flex;
`;

const Checkbox = styled(CheckboxA)`
  margin: 0;
  height: 15px;
  padding-left: 16px;
  user-select: none;
`;

const PopupHeaderWrapper = styled('div')`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
`;

const RowWrapper = styled('div')`
  display: flex;
  width: 100%;
  flex-direction: row;
  min-height: 45px;
  align-items: center;
  border-top: 2px solid var(--ph-gray-50);
  color: var(--black);

  &:last-child {
    border-bottom: 2px solid var(--ph-gray-50);
  }
`;

const RowLabel = styled('label')`
  color: var(--ph-gray-600);
  font-size: var(--ph-text-sm);
  margin-left: 2px;
`;

const RowCell = styled('div')`
  padding: 0 5px;

  &.name {
    flex-basis: 30%;
    padding-left: 25px;
  }

  &.email {
    flex-basis: 45%;
  }

  &.type {
    flex-basis: 15%;
  }

  &.checkbox {
    flex-basis: 10%;
    display: flex;
    justify-content: flex-end;
    padding-right: 20px;
  }
`;

const RowWrapperStacked = styled('div')`
  display: flex;
  width: 100%;
  flex-direction: column;
  min-height: 45px;
  align-items: flex-start;
  color: var(--black);
  justify-content: center;
  padding-left: 25%;
  padding-right: 25%;
`;

export default {
  BottomInfoWrapper,
  BottomWrapper,
  Button,
  ButtonsWrapper,
  Checkbox,
  PopupHeaderWrapper,
  RowLabel,
  RowCell,
  RowWrapper,
  RowWrapperStacked
};
